import { useDirectUpload } from "@circle-react/hooks/useDirectUpload";
import isFunction from "lodash/isFunction";
import { useEffect } from "react";

import { useEmojiPickerV4Context } from "../EmojiPickerV4Context";

interface UseCustomIconUploadArgs {
  close: () => void;
}

export const useCustomIconUpload = ({ close }: UseCustomIconUploadArgs) => {
  const upload = useDirectUpload();
  const { uploadFile, progress, status, response, isError } = upload;

  const {
    handleCustomIconUpload,
    shouldCloseOnSelect,
    setIsCustomFileUploadProcessing,
  } = useEmojiPickerV4Context();

  useEffect(() => {
    if (isFunction(handleCustomIconUpload)) {
      handleCustomIconUpload({ status, progress, response, isError });
    }
  }, [status, progress, response, isError, handleCustomIconUpload]);

  useEffect(() => {
    if (status === "uploading") {
      setIsCustomFileUploadProcessing(true);
      return undefined;
    }
    if (status === "error") {
      setIsCustomFileUploadProcessing(false);
      return undefined;
    }
    if (status === "completed") {
      setIsCustomFileUploadProcessing(false);
      if (response && shouldCloseOnSelect) {
        const id = window.setTimeout(close, 1000);
        return () => window.clearTimeout(id);
      }
    }
    return undefined;
  }, [
    status,
    response,
    shouldCloseOnSelect,
    close,
    setIsCustomFileUploadProcessing,
  ]);

  return {
    uploadFile,
    status,
    isError,
    response,
    progress,
    isUploading: !isError && status === "uploading",
  };
};
